const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/defs/colors.ts';
export const colors = {
    typography: {
        primary: '#212121', // Primary Text
        secondary: '#757575', // Secondary Text
        placeholder: '#9E9E9E', // Placeholder, inactive
    },
    interaction: {
        primary: '#1769B6', // Primary Text
    },
    blue: {
        100: '#F3F8FC',
        150: '#E7F2FA',
        200: '#DDEBF8',
        300: '#C4DDF4',
        400: '#AFD1F0',
        425: '#80B6EA',
        450: '#4594E1',
        500: '#1C7CD6',
        600: '#1769B6', // PRIMARY INTERAKTIONSFARBE
        700: '#00529E',
        A400: '#1C7CD6', // status info
        A800: '#0B3155', // status info text
    },
    brown: {
        150: '#F1EDEC',
        200: '#EBE5E3',
        300: '#DBC3B8',
        400: '#D0C3BE',
        425: '#B5A198',
        500: '#7A5547',
        700: '#523930',
    },
    common: {
        black: '#000',
        white: '#fff',
    },
    cyan: {
        200: '#DBEFF2',
        300: '#C0E3E9',
        400: '#ABDBE2',
        425: '#78C6D2',
        500: '#1098AD',
        700: '#0A6775',
    },
    deepPurple: {
        200: '#E7E1F9',
        300: '#D7CDF5',
        400: '#C9BCF1',
        425: '#AB94EC',
        500: '#6741D9',
        700: '#452C93',
    },
    green: {
        100: '#F5FAF6',
        150: '#EAF5EC',
        200: '#DFF0E2',
        300: '#c8e5cd',
        400: '#b6ddbd',
        425: '#8ACA96',
        500: '#2f9e44',
        700: '#1f6b2e',
        800: '#195725',
        A400: '#2F9E44', // status success
        A800: '#123F1B', // status success Text
    },
    lime: {
        200: '#E9F4DB',
        300: '#DCEDC5',
        400: '#CEE6AD',
        425: '#B1D879',
        500: '#74B816',
        700: '#50800F',
    },
    // DEPRECATED, use lime colors
    lightGreen: {
        200: '#E9F4DB',
        300: '#DCEDC5',
        400: '#CEE6AD',
        500: '#74B816',
        700: '#50800F',
    },
    grey: {
        50: '#fafafa', // primary content areas, cards
        100: '#f5f5f5', // secondary content areas
        150: '#f2f2f2', // background of headers in lists
        200: '#eeeeee',
        300: '#e0e0e0', // background behind cards, border color dividers

        // Other grey scale values may be used, but you should prefer the ones above.
        215: '#d7d7d7',
        325: '#d8d8d8',
        350: '#cfcfcf',
        400: '#bdbdbd',
        500: '#9e9e9e',
        600: '#757575', // Typography  Secondary
        700: '#616161',
        800: '#424242',
        900: '#212121', // Typography Primary
    },
    orange: {
        100: '#FEF7F2',
        150: '#FEEFE5',
        200: '#FDE8DA',
        300: '#FFDCBF',
        400: '#FCC9A8',
        425: '#FCAB71',
        450: '#F88847',
        500: '#F76707',
        700: '#A74504',
        800: '#8D3902',
        A200: '#FF8B66', // light; @kis-color-accent-fb2
        A400: '#FF6E40', // main; @kis-color-accent-fb
        A700: '#d95e36', // dark; @kis-color-accent
        A800: '#662C19', // status attention text
    },
    pink: {
        200: '#F8E0E9',
        300: '#F4CAD8',
        400: '#F0B7CB',
        425: '#EA8DAD',
        500: '#D6336C',
        700: '#912249',
    },
    purple: {
        100: '#FAF5FC',
        150: '#F7ECF9',
        200: '#F2E2F6',
        300: '#EACDF1',
        400: '#E2BAEB',
        425: '#D393E3',
        500: '#AE3EC9',
        700: '#762A88',
    },
    red: {
        200: '#FCE1E1',
        300: '#FBCDCD',
        400: '#F9BBBB',
        425: '#F69595',
        500: '#F03E3E',
        700: '#A22A2A',
        A400: '#D50000', // status error
        A800: '#550000', // status error text
    },
    teal: {
        100: '#f7fdf8',
        200: '#d7f1e4',
        300: '#8ab9ab',
        500: '#089e71',
        600: '#047552',
    },
    yellow: {
        150: '#FEFAE4',
        200: '#FEF8D9',
        300: '#FDF3C0',
        400: '#FDEEA6',
        425: '#FDE66C',
        500: '#FAD105',
        700: '#F9A825',
        800: '#F9A825',
        A400: '#FFEB3B',
        A800: '#665500',
    },
    special: {
        wundDokuFreehandFg: '#38F2D0', // @see UXPROJ-40
    },
    highlight: {
        red: {
            200: '#FFBDBD',
            500: '#FF0000',
        },
        orange: {
            200: '#FFDEBD',
            500: '#FFC000',
        },
        yellow: {
            200: '#FEFECA',
            500: '#FFFF00',
        },
        green: {
            200: '#ACFF9D',
            500: '#39FF14',
        },
        cyan: {
            200: '#BCFBEF',
            500: '#38F2D0',
        },
        blue: {
            200: '#CCF7FF',
            500: '#9AE0FF',
        },
        magenta: {
            200: '#FED7FD',
            500: '#FF00FF',
        },
    },
};

export const kisimColors: { [colName: string]: string } = {
    PrimaryKurvenBlau: colors.interaction.primary,
    PrimaryBlau200: '#2c5d7f',
    PrimaryBlau100: '#3976a3',
    AccentRot100: '#ff5f50',
    LayoutGrau600: '#939598',
    LayoutGrau500: '#b4b4b4',
    LayoutGrau400: '#e2e2e2',
    LayoutGrau300: colors.grey[150],
    LayoutGrau200: colors.grey[50],
    LayoutWeiss100: '#ffffff',
    TypoSchwarz300: colors.typography.primary,
    GreyText: colors.typography.secondary,
    GreyInactive: colors.typography.placeholder,
    HoverBlau: colors.blue[700],
    TypoGrau200: '#58595b',
    TypoGrau100: colors.typography.secondary,
    TypoGrau100P: '#b9b9b9',
    SuccessGruen: '#35873d',
    InfoBlau: colors.blue[500],
    ErrorRot: colors.red.A400,
    AttentionOrange: colors.orange[500],
    WarnYellow: colors.yellow[500],
    Rot100: '#fef5f5',
    Rot200: colors.red[200],
    Rot300: colors.red[300],
    Rot400: colors.red[400],
    Rot425: colors.red[425],
    Rot500: colors.red[500],
    Rot700: colors.red[700],
    Pink100: '#fcf4f7',
    Pink200: colors.pink[200],
    Pink300: colors.pink[300],
    Pink400: colors.pink[400],
    Pink425: colors.pink[425],
    Pink500: colors.pink[500],
    Pink700: colors.pink[700],
    Traube100: colors.purple[100],
    Traube200: colors.purple[200],
    Traube300: colors.purple[300],
    Traube400: colors.purple[400],
    Traube425: colors.purple[425],
    Traube500: colors.purple[500],
    Traube700: colors.purple[700],
    Purple100: '#f7f5fd',
    Purple200: colors.deepPurple[200],
    Purple300: colors.deepPurple[300],
    Purple400: colors.deepPurple[400],
    Purple425: colors.deepPurple[425],
    Purple500: colors.deepPurple[500],
    Purple700: colors.deepPurple[700],
    Blau100: colors.blue[100],
    Blau200: colors.blue[200],
    Blau300: colors.blue[300],
    Blau400: colors.blue[400],
    Blau425: colors.blue[425],
    Blau500: colors.blue[500],
    Blau700: '#125491',
    Cyan100: '#f3fafb',
    Cyan200: colors.cyan[200],
    Cyan300: colors.cyan[300],
    Cyan400: colors.cyan[400],
    Cyan425: colors.cyan[425],
    Cyan500: '#109bad',
    Cyan700: colors.cyan[700],
    Gruen100: colors.green[100],
    Gruen200: colors.green[200],
    Gruen300: colors.green[300],
    Gruen400: colors.green[400],
    Gruen425: colors.green[425],
    Gruen500: colors.green[500],
    Gruen700: colors.green[700],
    Limone100: '#f8fbf4',
    Limone200: colors.lime[200],
    Limone300: colors.lime[300],
    Limone400: colors.lime[400],
    Limone425: colors.lime[425],
    Limone500: colors.lime[500],
    Limone600: '#629c12',
    Gelb100: '#fefcf2',
    Gelb200: colors.yellow[200],
    Gelb300: colors.yellow[300],
    Gelb400: colors.yellow[400],
    Gelb425: colors.yellow[425],
    Gelb500: colors.yellow[500],
    Gelb600: '#d4b104',
    Orange100: colors.orange[100],
    Orange200: colors.orange[200],
    Orange300: colors.orange[300],
    Orange400: colors.orange[400],
    Orange425: colors.orange[425],
    Orange500: colors.orange[500],
    Orange700: colors.orange[700],
    Braun100: '#f8f7f6',
    Braun200: colors.brown[200],
    Braun300: '#ddd4d0',
    Braun400: colors.brown[400],
    Braun425: colors.brown[425],
    Braun450: '#95776a',
    Braun500: colors.brown[500],
    Braun700: colors.brown[700],
};
